<template>
    <div id="webList">
        <div class="list">
            <div
                class="item"
                style="border-bottom: 1px solid var(--lang-list-secondary); color: red;"
                v-for="(item, index) in listData"
                :key="index"
                @click="() => itemClickHandler(item)"
            >
                <div class="text">
                    {{ item[showKey] }}
                </div>
                <div v-if="selectItem && selectItem[showKey] === item[showKey]" class="select-icon">
                    <EllipsIconButton :padding="'9px'" :iconName="'Check'" bg-color="var(--primary_)" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EllipsIconButton from "./IconButton.vue";
export default {
    components: { EllipsIconButton },
    name: "WebList",
    props: {
        listValue: { default: [] },
        showKey: { default: "" },
        searchValue: { default: null },
        defaultSelected: { default: null },
    },
    data() {
        return {
            selectItem: null,
            listData: this.listValue,
        };
    },
    methods: {
        itemClickHandler(item) {
            this.selectItem = item;
            this.$emit("itemClicked", item);
        },
    },
    watch: {
        searchValue() {
            if (this.searchValue === null) return;
            this.listData = this.listValue.filter((item) =>
                item[this.showKey].toLowerCase().includes(this.searchValue.toLowerCase())
            );
        },
    },
    mounted() {
        if (this.defaultSelected !== null) {
            this.selectItem = this.listData.find((item) => item[this.showKey] === this.defaultSelected[this.showKey]);
        }
    },
};
</script>
<style lang="scss">
#webList {
    width: 100%;

    .list {
        width: 100%;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-bottom: 40px;

        .item {
            display: flex;
            justify-content: space-between;
            padding: 13px 22px;
            cursor: pointer;
            user-select: none;

            .text {
                color: var(--primary-text);
                font-size: 14px;
                font-weight: 400;
                line-height: 21px;
            }

            .select-icon {
                svg {
                    width: 10px;
                    height: 10px;
                    padding: 0;
                    margin: 0;
                }

                path {
                    padding: 0;
                    margin: 0;
                }
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/common/WebList.vue